import React, {useState, useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import DashboardHeader from '../dashboardHeader'
import DashBoardContainer from '../../../components/containers/dashboardContainer'
import {
    updateFirmApplication,
    fetchFirmApplicationStatus as fetchFirmApplication,
    fetchFile

} from '../../../actions'
import Attachments from '../../../components/attachments'
import {SUBMIT_FIRM_APPLICATION_ID} from '../../../store/loaders'
import { v4 as uuidv4 } from 'uuid'
import PopupModel from '../../../components/models/popupModel'







const CompanyAttachments = (props)=>{

    const history = useHistory()
    const dispatch = useDispatch()


    const apiResponse = useSelector((state=>{
        const {
            firmApplication, 
            loader,
            firmApplicationSubmitted,
            hasUpdatedFirm,
            fetchFile
        } = state
        const {application} = firmApplication
        const {isLoading} = loader[SUBMIT_FIRM_APPLICATION_ID] || {isLoading: false}
        const {response} = firmApplicationSubmitted
        const {updateId} = hasUpdatedFirm
        const {file} = fetchFile


        return{
            application,
            isLoading,
            response,
            updateId,
            file
        }
    }))

    const [rraReport, setRraReport] = useState('')
    const [rssbReport, setRssbReport] = useState('')
    const [rdbreport, setRdbreport] = useState('')
    const [companyProfile, setCompanyProfile] = useState('')
    const [managingReport, setManagingReport] = useState('')
    const [businessReport, setBusinessReport] = useState('')
    const [technicalReport, setTechnicalReport] = useState('')
    const [cv, setCv] = useState('')
    const [applicationDetails, setApplicationDetails] = useState({})
    const [requestId, setRequestId] = useState('')
    const [fileModel, showFileModel] = useState(false)



    const applicationId = apiResponse.application?.applicationId || apiResponse.application?.id
    var actionLoader = apiResponse.isLoading
    const appId = props.location.state && props.location.state.application?.id



    useEffect(()=>{
        dispatch(fetchFirmApplication(appId))
    },[])

    const [hasDownloaded, setHasDownloaded] = useState(false)
    const [download, setDownload] = useState(false)

    useEffect(()=>{
        if(apiResponse.response?.status === 'success'){
            dispatch(fetchFirmApplication(appId))
        }
    },[apiResponse.response])

    useEffect(()=>{
        if(apiResponse.updateId === requestId && apiResponse.response?.status === 'success'){
            history.push({
                pathname: '/dashboard',
                state: applicationDetails
            })
        }
    },[apiResponse.updateId])

    useEffect(()=>{
        if(applicationId){
            setApplicationDetails({
                ...apiResponse.application
            })
        }
    },[apiResponse.application])

    useEffect(()=>{
        if(apiResponse.file?.fileText != null && !hasDownloaded && download){
            var a = document.createElement("a");
            a.href =  "data:image/" +apiResponse.file?.type +";base64," + apiResponse.file?.fileText; 
            a.download = apiResponse.file?.name || 'File' + "." + apiResponse.file?.type || ''; 
            a.click();
            setHasDownloaded(true)
        }
    },[apiResponse.file])

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });


    var technicalurl, 
        businessUrl, 
        managingUrl, 
        profileUrl, 
        rdbUrl, 
        rssbUrl, 
        rraUrl,
        technicalReportFile,
        businessCertificateDocumentFile,
        rssbCertificateDocumentFile,
        taxClearanceDocumentFile,
        rdbRegistrationDocumentFile,
        practicingLicenseDocumentFile,
        companyProfileDocumentFile,
        cvUrl,
        cvFile

    const handleSaveForLater = async ()=>{
            const reqId = uuidv4()
            setRequestId(reqId)

        if(technicalReport.length > 0){
            var test = await toBase64(technicalReport[0]).then(value=>{
                technicalurl = value.split(',')[1]
            })
            technicalReportFile = {technicalReportFile:{
                fileText: technicalurl,
                type: technicalReport[0]?.name?.split('.')?.pop(),
                name: technicalReport[0]?.name,
                changed: true
                }
            }
        }
        if(cv.length > 0){
            var test = await toBase64(cv[0]).then(value=>{
                cvUrl = value.split(',')[1]
            })
            cvFile = {cv:{
                fileText: cvUrl,
                type: cv[0]?.name?.split('.')?.pop(),
                name: cv[0]?.name,
                changed: true
                }
            }
        }
        if(businessReport.length > 0){
            var test = await toBase64(businessReport[0]).then(value=>{
                businessUrl = value.split(',')[1]
                
            })
            businessCertificateDocumentFile = {businessCertificateDocumentFile:{
                fileText: businessUrl,
                type:businessReport[0]?.name?.split('.')?.pop(),
                name: businessReport[0]?.name,
                changed: true
            }}
        }
        if(managingReport.length > 0){
            var test = await toBase64(managingReport[0]).then(value=>{
                managingUrl = value.split(',')[1]
            })
            practicingLicenseDocumentFile={
                practicingLicenseDocumentFile:{
                    fileText: managingUrl,
                    type:managingReport[0]?.name?.split('.')?.pop(),
                    name: managingReport[0]?.name,
                    changed: true
                },
            }
        }
        if(companyProfile.length > 0){
            var test = await toBase64(companyProfile[0]).then(value=>{
                profileUrl = value.split(',')[1]
            })
            companyProfileDocumentFile = {
                companyProfileDocumentFile:{
                    fileText: profileUrl,
                    type:companyProfile[0]?.name?.split('.')?.pop(),
                    name: companyProfile[0]?.name,
                    changed: true
                }
            }
        }
        if(rdbreport.length > 0){
            var test = await toBase64(rdbreport[0]).then(value=>{
                rdbUrl = value.split(',')[1]
            })
            rdbRegistrationDocumentFile={
                rdbRegistrationDocumentFile:{
                    fileText: rdbUrl,
                    type:rdbreport[0]?.name?.split('.')?.pop(),
                    name: rdbreport[0]?.name,
                    changed: true
                }
            }   
        }
        if(rssbReport.length > 0){
            var test = await toBase64(rssbReport[0]).then(value=>{
                rssbUrl = value.split(',')[1]
            })
            rssbCertificateDocumentFile={
                rssbCertificateDocumentFile:{
                    fileText:rssbUrl,
                    type:rssbReport[0]?.name?.split('.')?.pop(),
                    name: rssbReport[0]?.name,
                    changed: true
                },
            }
        }

        if(rraReport.length > 0){
            var test = await toBase64(rraReport[0]).then(value=>{
                rraUrl = value.split(',')[1]
            })
            taxClearanceDocumentFile={
                taxClearanceDocumentFile:{
                    fileText: rraUrl,
                    type:rraReport[0]?.name?.split('.')?.pop(),
                    name: rraReport[0]?.name,
                    changed: true
                }
            }
        }

        var attachments = {
                ...technicalReportFile,
                ...businessCertificateDocumentFile,
                ...rssbCertificateDocumentFile,
                ...taxClearanceDocumentFile,
                ...rdbRegistrationDocumentFile,
                ...practicingLicenseDocumentFile,
                ...companyProfileDocumentFile,
                ...cvFile
            }
        const sentData = {
            ...applicationDetails,
            ...attachments
        }
         if(applicationId){
            dispatch(updateFirmApplication({
                data: {
                    ...sentData
                },
                id: applicationId,
                reqId: reqId
            }))
        }   
    }

    const handleSubmit = ()=>{
        history.push({
            pathname: '/applicant/company/review-details',
            state:{
                application:applicationDetails
            }
        })
        handleSaveForLater()
    }

    const handleCancel = ()=>{
        history.push({
            pathname: '/applicant/company/projects',
            state:{
                application:applicationDetails
            }
        })
     }


     const handleFileDownload = (value)=>{
        let url 
        if(value){
            url = encodeURIComponent(value.substring(value.indexOf("/tmp"), value.length))
            dispatch(fetchFile(url))
        }
        setDownload(true)
        setHasDownloaded(false)
    }


    return (
        <div>
            <DashboardHeader
                activeStep={6}
                application={applicationDetails}/>
            <DashBoardContainer
                handleSubmit={handleSubmit}
                handleCancel={handleCancel}
                middleTitle="Save for Later"
                handleSaveForLater={handleSaveForLater}
                disabled={actionLoader}
                loader={actionLoader}
                title="Next">
                   <div className="d-flex w-100" style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column'
                }}>
                    <span className="dashboard-green-text-header">
                        Company Attachments
                    </span>
                </div>
                {/* <div className="dashboarder-grey-contanier mb-4" style={{flexDirection: 'column'}}>
                  <Attachments
                    required={true}
                    title="Attach Technical report"
                    removeItem={()=>removeItem('technical')}
                    showFileModel={showFileModel}
                    savedFile={applicationDetails.technicalReportFile}
                    updateFilesCb={(file)=>setTechnicalReport(file)}/>
                    {applicationDetails.technicalReportFile && 
                        <span className="general-span-text-none-auto" style={{margin: 'auto'}}>{applicationDetails.technicalReportFile?.name}</span>
                    }
                </div> */}
                <div className="dashboarder-grey-contanier mb-4" style={{flexDirection: 'column'}}>
                  <Attachments
                    required={true}
                    title="Managing or technical director's resume"
                    // removeItem={()=>removeItem('cv')}
                    showFileModel={showFileModel}
                    savedFile={applicationDetails.cv}
                    updateFilesCb={(file)=>setCv(file)}
                    downloadFile={()=>handleFileDownload(applicationDetails.cv?.fileText)}
                    removeItem={()=> 
                        setApplicationDetails({
                        ...applicationDetails,
                        cv:{
                            fileText: '',
                            name: '',
                            type: '',
                            changed: '',
                            deleted: true
                        }
                    })}
                    />
                </div>
                <div className="dashboarder-grey-contanier mb-4" style={{flexDirection: 'column'}}>
                  <Attachments
                    required={true}
                    showFileModel={showFileModel}
                    title="Attach certified Business certificate"
                    savedFile={applicationDetails.businessCertificateDocumentFile}
                    updateFilesCb={(file)=>setBusinessReport(file)}
                    downloadFile={()=>handleFileDownload(applicationDetails.businessCertificateDocumentFile?.fileText)}
                    removeItem={()=> 
                        setApplicationDetails({
                        ...applicationDetails,
                        businessCertificateDocumentFile:{
                            fileText: '',
                            name: '',
                            type: '',
                            changed: '',
                            deleted: true
                        }
                    })}
                    />
                   
                </div>
                {/* <div className="dashboarder-grey-contanier mb-4" style={{flexDirection: 'column'}}>
                  <Attachments
                    required={true}
                    showFileModel={showFileModel}
                    title="Attach RDB Registration Certificate"
                    updateFilesCb={(file)=>setRdbreport(file)}
                    savedFile={applicationDetails.rdbRegistrationDocumentFile}
                    downloadFile={()=>handleFileDownload(applicationDetails.rdbRegistrationDocumentFile?.fileText)}
                    removeItem={()=> 
                        setApplicationDetails({
                        ...applicationDetails,
                        rdbRegistrationDocumentFile:{
                            fileText: '',
                            name: '',
                            type: '',
                            changed: '',
                            deleted: true
                        }
                    })}
                    />
                  
                </div> */}
                <div className="dashboarder-grey-contanier mb-4" style={{flexDirection: 'column'}}>
                  <Attachments
                    required={true}
                    showFileModel={showFileModel}
                    title="Attach Managing/Technical Director’s Practicing License"
                    updateFilesCb={(file)=>setManagingReport(file)}
                    savedFile={applicationDetails.practicingLicenseDocumentFile}
                    downloadFile={()=>handleFileDownload(applicationDetails.practicingLicenseDocumentFile?.fileText)}
                    removeItem={()=> 
                        setApplicationDetails({
                        ...applicationDetails,
                        practicingLicenseDocumentFile:{
                            fileText: '',
                            name: '',
                            type: '',
                            changed: '',
                            deleted: true
                        }
                    })}
                    />
                  
                </div>
                <div className="dashboarder-grey-contanier mb-4" style={{flexDirection: 'column'}}>
                  <Attachments
                    required={true}
                    showFileModel={showFileModel}
                    title="Attach Company Profile"
                    updateFilesCb={(file)=>setCompanyProfile(file)}
                    savedFile={applicationDetails.companyProfileDocumentFile}
                    downloadFile={()=>handleFileDownload(applicationDetails.companyProfileDocumentFile?.fileText)}
                    removeItem={()=> 
                        setApplicationDetails({
                        ...applicationDetails,
                        companyProfileDocumentFile:{
                            fileText: '',
                            name: '',
                            type: '',
                            changed: '',
                            deleted: true
                        }
                    })}
                    />
                 
                </div>

                <div className="dashboarder-grey-contanier mb-4" style={{flexDirection: 'column'}}>
                  <Attachments
                    required={true}
                    showFileModel={showFileModel}
                    title="Attach RSSB Certificate"
                    updateFilesCb={(file)=>setRssbReport(file)}
                    savedFile={applicationDetails.rssbCertificateDocumentFile}
                    downloadFile={()=>handleFileDownload(applicationDetails.rssbCertificateDocumentFile?.fileText)}
                    removeItem={()=> 
                        setApplicationDetails({
                        ...applicationDetails,
                        rssbCertificateDocumentFile:{
                            fileText: '',
                            name: '',
                            type: '',
                            changed: '',
                            deleted: true
                        }
                    })}
                    /> 
                   
                </div>
                <div className="dashboarder-grey-contanier" style={{flexDirection: 'column'}}>
                  <Attachments
                    required={true}
                    showFileModel={showFileModel}
                    title="Attach RRA Tax Clearance Certificate"
                    updateFilesCb={(file)=>setRraReport(file)}
                    savedFile={applicationDetails.taxClearanceDocumentFile}
                    downloadFile={()=>handleFileDownload(applicationDetails.taxClearanceDocumentFile?.fileText)}
                    removeItem={()=> 
                        setApplicationDetails({
                        ...applicationDetails,
                        taxClearanceDocumentFile:{
                            fileText: '',
                            name: '',
                            type: '',
                            changed: '',
                            deleted: true
                        }
                    })}
                    />
                </div>
                <PopupModel
                    show={fileModel}
                    hide={()=>showFileModel(false)}
                    content="File uploaded is too big"
                    btnText="OK"
                    handleConfirm={()=>showFileModel(false)}
                    />
            </DashBoardContainer>
        </div>
    )
}

export default CompanyAttachments